var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"running-text"},[_c('marquee-text',{attrs:{"duration":15,"repeat":10}},[_c('span',{staticClass:"running-text__item"},[_vm._v("\n      Весь модельный ряд в наличии! Звоните, мы гарантируем выгодное предложение!\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }